@if (display) {
	<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{ title }}" [(visible)]="display" showEffect="fade" [modal]="true" appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
		<!-- #region BODY -->
		<div class="container-md">
			<!-- DRIVER -->
			<div class="row justify-content-start mt-3">
				<div class="col-sm-4">
					<form-input
						[required]="true"
						[align]="'stacked'"
						fieldName="{{ 'tableManagement.fine.driver' | translate }}"
					>
						<p-select
							[options]="driverList"
							[(ngModel)]="entity.driver"
							placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.fine.driver' | translate }}"
							dataKey="id"
							optionLabel="fullName"
							[style]="{ width: '100%' }"
							appendTo="body"
							[filter]="true"
							(onChange)="onChangeDriver($event)"
							(onFilter)="onFilterDriver($event)"
						>
							<ng-template let-driver pTemplate="item">
								<div class="flex align-items-center gap-2">
									<div>
										({{ driver.employee.code }}) {{ driver.employee.user.surname1 }}
										{{ driver.employee.user.surname2 }}
										{{ driver.employee.user.name }}
									</div>
								</div>
							</ng-template>
						</p-select>
					</form-input>
				</div>
				<div class="col-sm-4">
					<form-input
						[required]="true"
						[align]="'stacked'"
						fieldName="{{ 'tableManagement.cardLists.assignDateShort' | translate }}"
					>
						<p-datepicker
							[(ngModel)]="startDate"
							[showTime]="false"
							[style]="{ width: '100%' }"
							dateFormat="{{ i18n.dateFormat }}"
							showIcon="true"
							appendTo="body"
							[firstDayOfWeek]="1"
							[minDate]="minStartDate"
							[maxDate]="maxStartDate"
						></p-datepicker>
					</form-input>
				</div>
				<div class="col-sm-4">
					<form-input
						[required]="false"
						[align]="'stacked'"
						fieldName="{{ 'tableManagement.cardLists.deassignDateShort' | translate }}"
					>
						<p-datepicker
							[(ngModel)]="endDate"
							[showTime]="false"
							[style]="{ width: '100%' }"
							dateFormat="{{ i18n.dateFormat }}"
							showIcon="true"
							appendTo="body"
							[firstDayOfWeek]="1"
						></p-datepicker>
					</form-input>
				</div>
			</div>
			<!-- DOCUMENTS -->
			@if (!isNew) {
				<div class="row mt-3">
					<app-doc-table
						type="driver_assignment"
						[entity]="entity"
						[nested]="true"
						[ids]="ids"
						(return)="refresh()"
					>
					</app-doc-table>
				</div>
			}
		</div>
		<!-- #endregion BODY -->
	</div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center bd-highlight">
				<div class="p-2 bd-highlight">
					@if (!isNew) {
						<div>
							<button class="btn custom-button" (click)="save()" [disabled]="!canUpdate" i18n>
								{{ 'general.save' | translate }}
							</button>
						</div>
					}
				</div>
			</div>
		</ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}
